import StopShow from './stopShow.vue'

export default StopShow
